import { useMemo } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

interface EventPageCountProps {
    contrast: boolean;
    page: number;
    totalPage: number;
    tabIndex: number;
}

const EventPageCount = ({ contrast, page, totalPage, tabIndex }: EventPageCountProps) => {
    const { t } = useTranslation();

    const countClassname = useMemo(() => {
        return clsx(styles['count'], contrast ? styles['count__contrast'] : '');
    }, [contrast]);

    return (
        <div
            data-region-nav
            data-region-order={tabIndex}
            className={countClassname}
            tabIndex={tabIndex}
            data-interactive
            aria-label={t('event.pagination_desc', { page, total: totalPage })}
        >
            <span className={clsx('number', styles['count__page'])}>{page}</span>
            <span className={clsx('number', styles['count__slash'])}>/</span>
            <span className={clsx('number', styles['count__total'])}>{totalPage}</span>
        </div>
    );
};

export default EventPageCount;
